

exports.__esModule = true;
exports.$xoSidebarAddCardPageComponent = undefined;

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _sharedUtil = require('../services/shared-util');

require('xo-page-components/src/aside-header/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-validation/dist/directive');

require('xo-wallet-components/src/add-card/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarAddCardPageComponent = exports.$xoSidebarAddCardPageComponent = _squid.$Component.extend('$xoSidebarAddCardPageComponent', {
    tag: 'xo-sidebar-add-card-page',
    template: _template2['default'],
    scope: {
        promotion: '=?',
        backUri: '=?',
        doneUri: '=?'
    },
    controller: ['$scope', function ($scope) {
        $scope.logSubscriptionEvent = _sharedUtil.$SharedUtil.logSubscriptionEvent(_angular.$rootScope && _angular.$rootScope.token);
        $scope.logSubscriptionEvent({
            from: 'sidebar_add_card_rendered',
            to: 'prepare_sidebar_add_card'
        });
        $scope.billingaddressupdated = {
            value: false
        };
        $scope.sidebar = true;
        $scope.token = _angular.$rootScope.token;
        $scope.message = {};
        $scope.callbacks = {
            finish: function finish() {
                $scope.logSubscriptionEvent({
                    from: 'sidebar_add_card_completed',
                    to: 'processing_sidebar_add_card'
                });
                _uiRouter.$state.go($scope.doneUri || 'checkout.review');
            }
        };
    }]
});

angular.value("$xoSidebarAddCardPageComponent", $xoSidebarAddCardPageComponent);
_angular.$rootScope;

_squid.$Component;

_uiRouter.$state;

_sharedUtil.$SharedUtil;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-add-card/directive.js
// module id = ./pages/xo-sidebar-add-card/directive.js
// module chunks = 0